import type { ReactNode } from 'react';
import { Montant, Nombre } from '../../../composants/ui/index.ts';
import type { Tableau } from '../types.ts';

/**
 * Meilleures ventes du jour, classées par montant — un vrai classement, donc
 * une numérotation (01, 02, 03…) : contrairement à des étapes numérotées
 * sans raison, l'ordre EST l'information ici.
 */
export function BlocClassement({
  lignes,
}: {
  lignes: NonNullable<Tableau['meilleures_ventes']>;
}): ReactNode {
  return (
    <div className="tdb-panneau">
      <header className="tdb-panneau__tete">
        <h2>Meilleures ventes du jour</h2>
        <p>Classées par montant vendu</p>
      </header>

      {lignes.length === 0 ? (
        <p className="table-vide">Aucune vente sur cette journée.</p>
      ) : (
        lignes.slice(0, 5).map((ligne, index) => (
          <div key={ligne.produit_id} className="tdb-rang">
            <span className="tdb-rang__num mono">{String(index + 1).padStart(2, '0')}</span>
            <div className="tdb-rang__nom">
              <strong>{ligne.designation}</strong>
              <span>
                <Nombre valeur={ligne.quantite} /> vendu(s)
              </span>
            </div>
            <span className="tdb-rang__montant mono">
              <Montant valeur={ligne.montant} />
            </span>
          </div>
        ))
      )}
    </div>
  );
}
